import { render } from "./AdvisorPage.vue?vue&type=template&id=6f5a0a16&scoped=true"
import script from "./AdvisorPage.vue?vue&type=script&lang=js"
export * from "./AdvisorPage.vue?vue&type=script&lang=js"

import "./AdvisorPage.vue?vue&type=style&index=0&id=6f5a0a16&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f5a0a16"]])

export default __exports__